module.exports = __webpack_public_path__ + "img/covid-table-02.804cfec1.png";